import classNames from 'classnames';
import * as bd from 'react-basic-design';

import React from 'react';
import SvgCheck from '../../../assets/icons/Check';
import SvgEast from '../../../assets/icons/East';
import { N } from '../../../components/basic/n';
import { T } from '../../../components/basic/text';

export const LicenseUploadSteps = ({
    onSelectStep,
    currentStep,
    allowedSteps,
}: {
    onSelectStep: (selectedStep: number) => void;
    currentStep: number;
    allowedSteps: number[];
}) => {
    const steps = [
        {
            id: 1,
            title: <T>upload-excel-file</T>,
            subTitle: <T>please-upload-the-excel-file-to-upload-license</T>,
        },
        {
            id: 2,
            title: (
                <>
                    <>
                        <span className="m-s-2">
                            <T className="small text-muted">preview-result</T>
                        </span>
                    </>
                </>
            ),
            subTitle: <T>please-review-the-result-before-submitting</T>,
        },
    ];

    const getCurrentStep = (step: number) => {
        switch (step) {
            case 1:
                return steps[0];
            case 2:
                return steps[1];
        }
        return steps[0];
    };

    const lastStep = getCurrentStep(currentStep);

    const selectStep = (newStep: { id: number }) => {
        if (newStep.id === currentStep) return;
        onSelectStep(newStep.id);
    };

    return (
        <div className="container py-4 mb-3">
            <bd.Flex gap={3} content="center">
                {steps.map((x, xIndex) => (
                    <React.Fragment key={x.id}>
                        {xIndex > 0 && <ArrowDown active={x.id <= lastStep.id} />}

                        <DisplayCalculationState
                            id={x.id}
                            label={x.title}
                            comment={x.subTitle}
                            active={allowedSteps.includes(x.id)}
                            isCurrent={x.id === currentStep}
                            onClick={() => selectStep(x)}
                        />
                    </React.Fragment>
                ))}
            </bd.Flex>
        </div>
    );
};

const DisplayCalculationState = ({
    id,
    active,
    isCurrent,
    label,
    comment,
    onClick,
}: {
    id: number;
    active: boolean;
    isCurrent: boolean;
    label: React.ReactNode;
    comment: React.ReactNode;
    onClick: () => void;
}) => {
    return (
        <bd.Flex
            vertical
            className={classNames('text-center', {
                'text-primary ': active,
                'text-muted': !active,
            })}
            align="center"
            gap={3}
            style={{ minWidth: 120 }}
        >
            <Number id={id} active={active} isCurrent={isCurrent} onClick={onClick} />
            <div className="">
                <T>{label}</T>
                {active && <div className="small text-muted pt-1">{comment}</div>}
            </div>
        </bd.Flex>
    );
};

const Number = ({
    id,
    active,
    isCurrent,
    onClick,
}: {
    id: number;
    active: boolean;
    isCurrent: boolean;
    onClick: () => void;
}) => (
    <bd.Flex
        align="center"
        content="center"
        className={classNames('rounded-circle border', {
            'border-primary bg-primary text-bg ': isCurrent,
            'border-primary bg-default text-primary cur-pointer': active && !isCurrent,
            'bg-shade-10 text-secondary-text': !active,
        })}
        style={{ width: 32, height: 32, fontSize: 20 }}
        onClick={() => active && !isCurrent && onClick()}
    >
        {isCurrent && <SvgCheck />}
        {!isCurrent && <N>{id}</N>}
    </bd.Flex>
);

const ArrowDown = ({ active }: { active: boolean }) => (
    <SvgEast
        className={classNames('mt-2 rtl-rotate-180 text-primary-text', {
            'text-shade-80': !active,
            'text-primary': active,
        })}
    />
);
